import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  lastVisitedRoute: string;
}

const initialState: UIState = {
  lastVisitedRoute: window.location.pathname,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setLastVisitedRoute(state, action: PayloadAction<string>) {
      state.lastVisitedRoute = action.payload;
    },
  },
});

export const { setLastVisitedRoute } = uiSlice.actions;
export default uiSlice.reducer;
